import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Analitica from './views/Analitica.vue'
import Estrategia from './components/Estrategias.vue'
import Responsable_Indicador from './components/Responsable_Indicador.vue'
import Indicador from './components/Indicadores.vue'
import Rol from './components/Rol.vue'
import Usuario from './components/Usuario.vue'
import Login from './components/Login.vue'
import store from './store'
import Empresas from './components/Empresas.vue'
import Perspectivas from './components/Perspectivas.vue'
import Objetivos from './components/Objetivos.vue'
import Maestra_Indicadores from './components/Maestra_Indicadores.vue'
import Variables_Indicador from './components/Variables_Indicador.vue'



Vue.use(Router)

var router= new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Inicio',
      component: Home,
      meta: {
        administrador: true,
        analista: true,
        actualizador: true
      }
    },
    {
      path: '/',
      name: 'Analitica',
      component: Analitica,
      meta: {
        administrador: true,
        analista: true,
        actualizador: true
      }
    },
 {
      path: '/perspectivas',
      name: 'perspectivas',
      component: Perspectivas,
      meta: {
        administrador: true,
        actualizador: true
      }
    },
    {
      path: '/objetivos',
      name: 'objetivos',
      component: Objetivos,
      meta: {
        administrador: true,
        actualizador: true
      }
    },
    {
      path: '/maestra_indicadores',
      name: 'maestra_indicadores',
      component: Maestra_Indicadores,
      meta: {
        administrador: true,
        actualizador: true
      }
    },
    {
      path: '/responsable_indicador',
      name: 'responsable_indicador',
      component: Responsable_Indicador,
      meta: {
        administrador: true,
        actualizador: true
      }
    },
    {
      path: '/variables',
      name: 'variables',
      component: Variables_Indicador,
      meta: {
        administrador: true,
        analista: true
      }
    } ,    
    {
      path: '/indicadores',
      name: 'indicadores',
      component: Indicador,
      meta: {
        administrador: true,
        analista: true
      }
    } ,
    {
      path: '/roles',
      name: 'roles',
      component: Rol,
      meta: {
        administrador: true
      }
    } ,
    {
      path: '/usuarios',
      name: 'usuarios',
      component: Usuario,
      meta: {
        administrador: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        libre: true
      }
    }       
  ]
})


router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.libre)){
    next()
  }else if (store.state.usuario && store.state.usuario.rol == 'Administrador'){
    if(to.matched.some(record => record.meta.administrador)){
      next()
    }
  }else if (store.state.usuario && store.state.usuario.rol == 'Analista'){
    if(to.matched.some(record => record.meta.analista)){
      next()
    }
  }else if (store.state.usuario && store.state.usuario.rol == 'Actualizador'){
    if(to.matched.some(record => record.meta.actualizador)){
      next()
    }else{
      next({
        name: 'login'
      })
    }
  }
})

export default router